import counterScene from './counter';

export default counterScene;



// WEBPACK FOOTER //
// ./components/_scrollmagic/scenes/counter/index.js